var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndefiniteSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,2.159729V0.5c0-0.1943359-0.1123047-0.3701172-0.2880859-0.453125 c-0.1748047-0.0810547-0.3828125-0.0566406-0.5322266,0.0693359L16,1.0993042l-1.8203125,1.5169067 C14.0654297,2.7109375,14,2.8515625,14,3s0.0654297,0.2890625,0.1796875,0.3837891L16,4.9006958l1.1796875,0.9830933 C17.2714844,5.9609375,17.3847656,6,17.5,6c0.0722656,0,0.1445312-0.015625,0.2119141-0.046875 C17.8876953,5.8701172,18,5.6943359,18,5.5V4.180603C23.6663818,5.137207,28,10.0656128,28,16 c0,5.2130737-3.3467407,9.6474609-8,11.2999878v2.1104126C25.7754517,27.6843872,30,22.3293457,30,16 C30,8.9609985,24.7731934,3.135376,18,2.159729z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,27.0993042l-1.1796875-0.9830933c-0.1494141-0.125-0.3574219-0.1503906-0.5322266-0.0693359 C14.1123047,26.1298828,14,26.3056641,14,26.5v1.319397C8.3336182,26.862793,4,21.9343872,4,16 c0-5.2130737,3.3467407-9.6474609,8-11.2999878V2.5895996C6.2245483,4.3156128,2,9.6706543,2,16 c0,7.0390015,5.2268066,12.864624,12,13.840271V31.5c0,0.1943359,0.1123047,0.3701172,0.2880859,0.453125 C14.3554688,31.984375,14.4277344,32,14.5,32c0.1152344,0,0.2285156-0.0390625,0.3203125-0.1162109L16,30.9006958 l1.8203125-1.5169067C17.9345703,29.2890625,18,29.1484375,18,29s-0.0654297-0.2890625-0.1796875-0.3837891L16,27.0993042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,18h8v-2h-8v-6h-2v6C14,17.1025391,14.8974609,18,16,18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndefiniteSmall);
export default __webpack_public_path__ + "static/media/indefinite--small.3968cec300696b012a3723c9927ce0f2.svg";
export { ForwardRef as ReactComponent };